import { render } from "./TalkroomMessages.vue?vue&type=template&id=279fd85b"
import script from "./TalkroomMessages.vue?vue&type=script&lang=js"
export * from "./TalkroomMessages.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TalkroomMessages.vue?vue&type=style&index=0&id=279fd85b&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__